import { ReactNode } from 'react';
import { IntercomProvider } from 'react-use-intercom';
import useAppConfig from 'hooks/useAppConfig';
import useAppInit from 'hooks/useAppInit';
import useAppUser from 'hooks/useAppUser';

const IntercomProviderWrapper = ({ children }: { children: ReactNode }) => {
  const { isInitInProgress } = useAppInit();
  const { user, isEmployee } = useAppUser();
  const { intercomAppId, showIntercom } = useAppConfig();

  if (!intercomAppId || isInitInProgress || !user) {
    if (!intercomAppId) {
      // eslint-disable-next-line no-console
      console.warn(
        'No intercomAppId found, returning children without Intercom provider',
      );
    }

    return children;
  }

  return (
    <IntercomProvider
      appId={intercomAppId}
      autoBoot={showIntercom && isEmployee}
      autoBootProps={{
        name: user.firstName,
        company: {
          companyId: user.agency.uid,
          name: user.agency.name,
          createdAt: user.agency.createdAtEpochSeconds,
          plan: user.agency.pricingPlanType,
        },
        customAttributes: {
          name: user.firstName,
          email: user.email,
          user_id: user.intercomId,
          user_hash: user.intercomHash,
          created_at: user.created,
          plan: user.agency.pricingPlanType,
          agency: user.agency.name,
          website: user.agency.website,
          agency_id: user.agency.uid,
          source: 'cluster',
        },
      }}
    >
      {children}
    </IntercomProvider>
  );
};

export default IntercomProviderWrapper;
